import { AccountsContext } from '../../../../components/context/account-context';
import { getVehicle, getVehicleOverview } from '../../../../services/vehicles-service';
import React, { useContext, useEffect, useState } from 'react'
import DataBoxes from './overview-components/data-boxes';
import Loader from '../../../../components/shared/loader';

const Overview = ({ vehicleId }) => {

    const { accountId,attributes } = useContext(AccountsContext);
    // const [dateRange, setDateRange] = useState({
    //     startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    //     endDate: new Date(),
    // });
    const [overview, setOverview] = useState();
    const [vehicle, setVehicle] = useState();
    const [loading, setLoading] = useState(true);
    const [vehicleloading, setVehicleLoading] = useState(true);
    const [error, setError] = useState(null);
    const [vehicleError, setVehicleError] = useState(null);


    const fetchVehicle = async () => {
        setVehicleLoading(true);
        try {
            const response = await getVehicle(accountId, vehicleId);
            if (response.success) {
                setVehicle(response.data.data);
                setVehicleError(null);
            } else {
                setVehicleError(response.data.message || "Failed to fetch vehicle details");
            }
        } catch (error) {
            setVehicleError("An error occurred while fetching vehicle details");
        } finally {
            setVehicleLoading(false);
        }
    };


    const fetchOverview = async () => {
        setLoading(true);
        try {
            // const { from, to } = getDateRangeUTC(dateRange);

            const response = await getVehicleOverview(accountId,vehicleId);
            console.log(response)

            if (response.success) {
                setOverview(response.data.data);
                setError(null);
            } else {
                setError(response.data.message || 'Failed to fetch vehicle overview');
            }
        } catch (err) {
            setError('An error occurred while fetching vehicle overview');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVehicle();
    }, [accountId, vehicleId]);

    useEffect(() => {
        fetchOverview();
    }, [accountId]);


    return (
        <div className="">
            {/* <DateRangePicker
                onChange={setDateRange}
                initialRange={{
                    startDate: dateRange.startDate,
                    endDate: dateRange.endDate,
                }}
            /> */}

            {(error || vehicleError) && (
                <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md">
                    {error || vehicleError}
                </div>
            )}

            {
                (loading || vehicleloading) ? <Loader />
                    :
                    <DataBoxes
                        vehicleDetails={vehicle}
                        overview={overview}
                        attributes={attributes}
                    />
            }


        </div>
    )
}

export default Overview
